/**
 * 定制蓝 — 在经典金基础上覆盖主题专属图片
 */
import classicGold from '../classic-gold/images';

export default {
  ...classicGold,
  logo: require('@/assets/custom-blue/cwpc-logo.png'),
  banner: require('@/assets/custom-blue/header-bg.png'),
  header: require('@/assets/custom-blue/header-bg.png'),
  bgi: require('@/assets/custom-blue/header-bg.png'),
  paymentSelected: require('@/assets/custom-blue/payment-method-selected.png'),
};
